import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LogisticaRepository } from '../../../services/logistica.repository';
import { LogisticaService } from '../../../services/logistica.service';
import { aFuncionalButtons, ametadatatable } from 'src/app/shared/componentes/a-table/domain/a.table.interface';
import { ATableComponent } from 'src/app/shared/componentes/a-table/presentacion/a-table/a-table.component';
import { StorageService } from 'src/app/services/storage.service';
import { ButtonModule } from 'primeng/button';
import { Toast } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { Ripple } from 'primeng/ripple';
import { EditorComponent, EditorModule } from 'smart-webcomponents-angular/editor';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { FloatLabelModule } from 'primeng/floatlabel';
import { FormModule } from 'src/app/shared/modulos/form.module';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CommonModule } from '@angular/common';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-proforma-agenciamiento-aduana',
  standalone: true,
  imports: [ATableComponent, ButtonModule, Toast, EditorModule, FormModule, DialogModule,
    ProgressSpinnerModule, CommonModule,
    FloatLabelModule, ReactiveFormsModule],
  providers: [
    { provide: LogisticaRepository, useClass: LogisticaService },
    MessageService
  ],
  changeDetection: ChangeDetectionStrategy.Default,
  templateUrl: './proforma-agenciamiento-aduana.component.html',
  styleUrl: './proforma-agenciamiento-aduana.component.css'
})
export class ProformaAgenciamientoAduanaComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private util: UtilService,
    private messageService: MessageService,
    private readonly servLogistica: LogisticaRepository,
    private readonly storage: StorageService,
  ) {

  }

  verDocCorreo = false;
  groupCorreo = this.fb.group({
    mailOrigen: ['', Validators.required],
    mailTo: ['', Validators.required],
    mailCc: [''],
    mailBcc: [''],
    subject: ['', Validators.required]
  });
  loadingEnvCorreo = false;
  @ViewChild('editor', { read: EditorComponent, static: false }) editor!: EditorComponent;
  toolbarItems: any = ['Bold', 'Italic', 'Underline', 'StrikeThrough',
    'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
    'LowerCase', 'UpperCase', '|',
    'Formats', 'Alignment', 'OrderedList', 'UnorderedList',
    'Outdent', 'Indent', '|',
    'hyperlink', 'table', 'Image', '|', 'ClearFormat', 'Print',
    'SourceCode', 'splitmode', 'FullScreen', '|', 'Undo', 'Redo', 'subscript', 'superscript', 'delete'];

  serviciosAdicionalesDt: any[] = []
  replicaServiciosDt: any[] = [] // <- segunda tabla
  titleTable1: string = 'Servicios de la Operacion HBL:'
  titleTable2: string = 'Servicios de la proforma'
  ccot_tipo: number = 0;
  guardado: boolean = false;
  loadingServicios: boolean = false;
  ngOnInit(): void {
    const row = this.config.data;
    this.ccot_tipo = row.ccot_tipo;
    this.titleTable1 += ` ${row.cope_hbl}`;
    this.loadingServicios = true;

    // 1. Obtener Servicios Asociados (La base de la tabla)
    this.servLogistica.ObtenerServiciosAsociados({
        ccot_numero: row.ccot_numero, ccot_tipo: row.ccot_tipo, audi_usr: this.storage.get('usuario')
    }).subscribe({
        next: (respAsociados) => {
            if (respAsociados.datos.status === 200) {
                console.log("ObtenerServiciosAsociados", respAsociados.datos.result);

                // ❗ Inicializa la tabla con todos los servicios asociados.
                // Inicialmente, marca todos como true. Esto se ajustará más adelante
                // cuando se obtenga la data de Proforma.
                this.serviciosAdicionalesDt = (respAsociados.datos.result || []).map((item: any) => ({
                    ...item,
                    check_seleccionados: true // Valor inicial por defecto (puede ser true/false)
                }));

                this.loadingServicios = false;

                // 2. Obtener Servicios Proforma (La base para el check)
                this.servLogistica.ObtenerServiciosProforma({
                    ccot_numero: row.ccot_numero, ccot_tipo: row.ccot_tipo, AUDI_Usr: this.storage.get('usuario')
                }).subscribe({
                    next: (respProforma) => {
                        if (respProforma.datos.status === 200 && respProforma.datos.result && respProforma.datos.result.length > 0) {
                            console.log("ObtenerServiciosProforma", respProforma.datos.result);
                            this.replicaServiciosDt = respProforma.datos.result;
                            this.guardado = true;

                            // ❗ Realizar el Match:
                            this.realizarMatch();

                        } else {
                            // Caso: ObtenerServiciosProforma está vacío o error 404
                            // ❗ Dejar todos los 'check_seleccionados' en true por defecto
                            console.log("Proforma vacía. Todos los checks en true por defecto.");
                            this.guardado = false; // Indica que es un nuevo guardado
                            // No se requiere acción, ya que se inicializaron en true arriba.
                            // Dejamos replicaServiciosDt como [] o lo que haya retornado.
                        }
                    },
                    error: (errProforma) => {
                        console.error('Error al obtener servicios Proforma:', errProforma);
                        // ❗ Manejo de error 404 (Si no hay data, todos los checks en true)
                        if (errProforma.error.datos.status === 404) {
                            console.log("Proforma no encontrada (404). Todos los checks en true por defecto.");
                            this.guardado = false;
                        } else {
                            // Otro error, podrías manejarlo de otra forma.
                        }
                    }
                });
            }
        },
        error: (errAsociados) => {
            console.error('Error al obtener los servicios asociados:', errAsociados);
            this.loadingServicios = false;
        }
    });
  }

  // Metadata común (para ambas tablas)
  mtServiciosAdicionalesTable: ametadatatable[] = [
    { field: { output: "check_seleccionados" }, header: { title: "Seleccionados" }, type: "checkboxAll" },//Esto no existe en mis tablas, se llenaran por el match de ccoT_Numero y item de ambas tablas
    { field: { output: "ccoT_Numero" }, header: { title: "N° Cotización" }, type: "text" },
    { field: { output: "item" }, header: { title: "Item" }, type: "text" },
    { field: { output: "descripcion" }, header: { title: "Descripción" }, type: "text" },
    { field: { output: "unidad_Base" }, header: { title: "Unidad Base" }, type: "text" },
    { field: { output: "tipo_Entidad" }, header: { title: "Tipo Entidad" }, type: "text" },
    { field: { output: "razon_Social" }, header: { title: "Razón Social" }, type: "text", styleColumn: { "max-width": "250px" } },
    { field: { output: "simbolo_Moneda" }, header: { title: "Moneda" }, type: "text" },
    { field: { output: "afe_Igv" }, header: { title: "Afecto IGV" }, type: "checkboxDisabled" },
    { field: { output: "precioUnitCosto" }, header: { title: "Precio Unit. Costo" }, type: "text" },
    { field: { output: "precioUnitProm" }, header: { title: "Precio Unit. Prom" }, type: "text" },
    { field: { output: "precioUnitVta" }, header: { title: "Precio Unit. Venta" }, type: "text" },
    { field: { output: "cantidad" }, header: { title: "Cantidad" }, type: "text" },
    { field: { output: "precioTotCosto" }, header: { title: "Total Costo" }, type: "text" },
    { field: { output: "precioTotProm" }, header: { title: "Total Prom" }, type: "text" },
    { field: { output: "precioTotVta" }, header: { title: "Total Venta" }, type: "text" },
    { field: { output: "codigo_Venta" }, header: { title: "Código Venta" }, type: "text" },
    { field: { output: "comprobante_Venta" }, header: { title: "Comprobante Venta" }, type: "text" },
  ]
  // 1. Nuevo Getter para calcular si todos están seleccionados
  get todosEstanSeleccionados(): boolean {
    const serviciosSeleccionables = this.serviciosAdicionalesDt
        .filter(item => item.statustable !== 'D'); // Filtrar por filas no eliminadas si aplica

    // Si no hay elementos, retorna false. Si hay elementos, verifica que todos estén en true.
    if (serviciosSeleccionables.length === 0) {
        return false;
    }

    // El método 'every' verifica si TODOS cumplen la condición
    return serviciosSeleccionables.every(item => item.check_seleccionados === true);
  }

  // ❗ Nueva función para realizar la lógica de match
  realizarMatch(): void {
    // 1. Crear un Set para una búsqueda eficiente de los servicios guardados
    // La clave de match es la combinación de ccoT_Numero e item.
    const proformaKeys = new Set(
        this.replicaServiciosDt.map(r => `${r.ccoT_Numero}-${r.item}`)
    );

    // 2. Iterar sobre la tabla original y establecer el check_seleccionados
    this.serviciosAdicionalesDt = this.serviciosAdicionalesDt.map(item => {
        const itemKey = `${item.ccoT_Numero}-${item.item}`;
        const isSelected = proformaKeys.has(itemKey);

        return {
            ...item,
            // Establece el check en true solo si se encuentra en la data de Proforma
            check_seleccionados: isSelected
        };
    });
    console.log("Tabla con Match aplicado:", this.serviciosAdicionalesDt);
  }

  // Botones
  rowFunctions: aFuncionalButtons[] = [
    {
      icon: "pi pi-copy", severity: "success", pTooltip: "Agregar a profoma",
      function: (row) => this.replicar(row),
      disabled: (row) =>
        row._replicado === true ||
        this.replicaServiciosDt.some(
          r => r.ccoT_Numero === row.ccoT_Numero && r.item === row.item
        )
    },
    {
      icon: "pi pi-trash", severity: "danger", pTooltip: "Eliminar de proforma",
      function: (row) => this.eliminarReplica(row),
      disabled: (row) =>
        !this.replicaServiciosDt.some(
          r => r.ccoT_Numero === row.ccoT_Numero && r.item === row.item
        )
    }
  ]

  replicar(row: any) {
    const existe = this.replicaServiciosDt.some(
      r => r.ccoT_Numero === row.ccoT_Numero && r.item === row.item
    );

    if (existe) {
      // Ya existe, no lo agregamos
      console.warn(`El item ${row.item} de la cotización ${row.ccoT_Numero} ya está en la proforma.`);
      return;
    }

    if (!row._replicado) {
      this.replicaServiciosDt.push({ ...row });
      row._replicado = true;
    }
  }


  eliminarReplica(row: any) {
    this.replicaServiciosDt = this.replicaServiciosDt.filter(
      r => !(r.ccoT_Numero === row.ccoT_Numero && r.item === row.item)
    );
    row._replicado = false;
  }

  hayCambiosPendientes(): boolean {
    // 1. Obtener la lista de servicios que el usuario TIENE seleccionados actualmente.
    const seleccionActual = this.serviciosAdicionalesDt
        .filter(item => item.check_seleccionados)
        .map(item => `${item.ccoT_Numero}-${item.item}`);

    // 2. Obtener la lista de servicios que FUERON guardados la última vez (replica).
    const seleccionGuardada = this.replicaServiciosDt
        .map(item => `${item.ccoT_Numero}-${item.item}`);

    // Si la cantidad de servicios es diferente, ya hay cambios.
    if (seleccionActual.length !== seleccionGuardada.length) {
        return true;
    }

    // 3. Si la cantidad es la misma, se verifica que los ítems sean idénticos.
    // Usamos Set para una búsqueda rápida y comparamos si cada ítem seleccionado
    // está presente en los guardados.
    const guardadosSet = new Set(seleccionGuardada);

    // Si alguno de los servicios seleccionados actualmente NO está en los guardados, hay un cambio.
    // Opcionalmente, puedes verificar también si algún servicio guardado NO está en la selección actual,
    // pero como ya comparamos los .length, con la primera verificación es suficiente si el length es el mismo.
    return seleccionActual.some(key => !guardadosSet.has(key));
  }

  get haySeleccionadosParaGuardar(): boolean {
    return this.serviciosAdicionalesDt.some(item => item.check_seleccionados === true);
  }

  get puedePrepararCorreo(): boolean {
    // 1. Que esté guardado.
    const estaGuardado = this.guardado;

    // 2. Que al menos un servicio esté seleccionado.
    const algunSeleccionado = this.serviciosAdicionalesDt.some(item => item.check_seleccionados === true);

    // 3. Que NO existan cambios pendientes.
    const noHayCambios = !this.hayCambiosPendientes();

    // El botón se HABILITA si: (1 Y 2 Y 3)
    return estaGuardado && algunSeleccionado && noHayCambios;
  }

  // función para guardar los servicios proforma
  guardarServicios(): void {
    // ❗ Filtra solo los elementos que tienen el check_seleccionados en true
    const serviciosParaGuardar = this.serviciosAdicionalesDt
        .filter(item => item.check_seleccionados === true)
        .map(item => ({
            ...item,
            ccot_tipo: this.ccot_tipo // Asegúrate de incluir el tipo si es necesario
            // Puedes eliminar la propiedad 'check_seleccionados' si el servicio no la espera
            // delete item.check_seleccionados;
            // Esto es más limpio:
            // const { check_seleccionados, ...itemSinCheck } = item; return itemSinCheck;
        }));

    console.log("Servicios a enviar para Guardar/Actualizar:", serviciosParaGuardar);

    if (serviciosParaGuardar.length === 0) {
        // Manejar el caso donde no hay nada seleccionado (Ej: mostrar un mensaje)
        console.warn("No hay servicios seleccionados para guardar.");
        this.messageService.add({ severity: 'warn', summary: 'Atención', detail: 'No hay servicios seleccionados para guardar.' });
        return;
    }
    const request = {
      AUDI_UsrCrea: this.storage.get('usuario'),
      Listado_Servicios: serviciosParaGuardar // aquí mandas tu data de la tabla
    }

    this.servLogistica.GuardarServiciosProforma(request).subscribe({
      next: (resp) => {
        if (resp.datos.status === 200) {
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Cambios guardados correctamente!' });
          // 💥 1. ACTUALIZA LA RÉPLICA CON LOS DATOS QUE SE ACABAN DE GUARDAR
          // Asumimos que el servicio no devuelve la lista completa y usamos la lista filtrada que enviamos.
          // Es crucial CLONAR el array para evitar mutaciones inesperadas.
          this.replicaServiciosDt = JSON.parse(JSON.stringify(serviciosParaGuardar));

          // 2. Establece el estado de guardado
          this.guardado = true;
        } else {
          this.messageService.add({ severity: 'info', summary: 'Info', detail: resp.meta.mensaje || 'No se guardaron cambios' });
          this.guardado = false;
        }
      },
      error: (err) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: err.meta.mensaje || 'Error al guardar los cambios' });
        this.guardado = false;
      }
    })
  }

  canal: any[] = [
    { label: "ROJO", value: '001' },
    { label: "VERDE", value: '002' },
    { label: "NARANJA", value: '003' },
  ]

  loadingEditor = false; // Variable para controlar el loading

  abrirDialogCorreo() {
    if (!this.guardado) return this.messageService.add({ severity: 'warn', summary: 'Atención', detail: 'Debe guardar los cambios antes de enviar el correo.' });
    const row = this.config.data;
    this.verDocCorreo = true;

    const obtenerCanal = this.canal.find(c => c.value === row.cons_codcan)?.label || "No definido";
    // Aquí construyes tu asunto con los datos de la fila (row)
    const asuntoConcatenado = `PROFORMA / CARGA NUMERADA CANAL ${obtenerCanal} / RO ${row.ccot_numdoc} / ${row.puer_codestandarorigen}-${row.puer_codestandardestino} / ${row.contenedor || "01X40HQ"} / ${row.entc_razonsocialcliente} / ${row.cope_hbl} / ${row.nave} / ${row.nroviaje} / ${new Date(row.eta_zarpe).toLocaleDateString()}`;

    this.groupCorreo.patchValue({
      mailOrigen: this.storage.get('correo'),
      mailTo: row.correo_cliente,
      mailCc: "",
      mailBcc: "",
      subject: asuntoConcatenado
    });

    // Contenido HTML inicial (mensaje + tabla)
    //!No se puede colocar el estilo en thead: style="background-color:#002060; color: white;"
    const contenidoHTMLInicial = `
      <p>Buen día.</p>
      <p>Estimado ${row.entc_razonsocialcliente}, detallo servicios pendientes de pago. Asimismo informo habrá costo adicional por servicio de aforo realizado a la carga cuando ésta ya se encuentre en almacén.</p>

      <table border="1" cellspacing="0" cellpadding="6" style="border-collapse: collapse; width: 70%; text-align: center;">
        <thead>
          <tr>
            <th colspan="4" style="text-align: center;">SERVICIO: AGENCIAMIENTO DE ADUANA</th>
          </tr>
          <tr>
            <th>Concepto</th>
            <th>Monto</th>
            <th>IGV</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          ${this.replicaServiciosDt.map(s => `
            <tr>
              <td>${s.descripcion}</td>
              <td>$ ${s.precioTotVta.toFixed(2)}</td>
              <td>$ ${(s.precioTotVta * 0.18).toFixed(2)}</td>
              <td>$ ${(s.precioTotVta * 1.18).toFixed(2)}</td>
            </tr>
          `).join('')}
          <tr style="background-color: yellow;">
            <td colspan="3" style="text-align: left;"><b>TOTAL</b></td>
            <td><b>$ ${this.replicaServiciosDt.reduce((sum, s) => sum + (s.precioTotVta * 1.18), 0).toFixed(2)}</b></td>
          </tr>
        </tbody>
      </table>

      <p style="margin-top:15px;">En copia mi compañero Oscar quien estará a cargo de la operación durante mi periodo de vacaciones.</p>
    `;

    this.loadingEditor = true;

    // Asigna el contenido inicial al editor para mostrarlo de inmediato
    if (this.editor) {
      this.editor.value = contenidoHTMLInicial;
    }

    this.servLogistica.obtenerFirmaUsuario({ usuario: this.storage.get('usuario') }).subscribe({
      next: (imagenes) => {
        console.log("imagenes", imagenes);
        if (imagenes.mensaje && imagenes.mensaje.includes("no fueron encontradas")) {
          this.messageService.add({ severity: 'warn', summary: 'Aviso', detail: imagenes.mensaje });
        }
        const chatbotHtml = imagenes.chatbotUrl ? `<img src="${imagenes.chatbotUrl}" width="150" alt="Chatbot"/>` : '';
        const firmaHtml = imagenes.firmaUrl ? `<img src="${imagenes.firmaUrl}" width="800" alt="Firma"/>` : '';

        // Ahora, construye el HTML final combinando el contenido inicial con las imágenes
        const contenidoHTMLFinal = `${contenidoHTMLInicial}
        <p><b>WhatsApp:</b> +51 919 295 166</p>
        ${chatbotHtml}
        <br/>
        <p>Lo invitamos a contactarlo.</p>
        <p style="color: blue; font-size: smaller">Best Regards / Saludos Cordiales / Mit freundlichen Grüßen / التَّحِيَّات أَطيَب مَع /  此致敬意 / 敬具 / 베스트감사합니다</p>
        ${firmaHtml}`;

        // Asigna el contenido HTML final al editor
        if (this.editor) {
          this.editor.value = contenidoHTMLFinal;
        }
        this.loadingEditor = false;
      },
      error: (err) => {
        const mensaje = err.error?.meta?.mensaje || err.meta?.mensaje || 'Error al obtener la firma del usuario';
        this.messageService.add({ severity: 'error', summary: 'Error', detail: mensaje });        // Manejo del error, por ejemplo, mostrar un HTML sin las imágenes
        if (this.editor) {
          this.editor.value = contenidoHTMLInicial;
        }
        this.loadingEditor = false;
      }
    });
  }

  correoValid(): boolean {
    return this.groupCorreo.valid && !!this.editor?.value;
  }

  manejoPopUpCorreoSolicitudDocumentos(tipo: string) {
    if (tipo === 'C') this.verDocCorreo = false;
  }

  enviarCorreoSolicitudDocumentos(): void {
    if (this.groupCorreo.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Atención', detail: 'Completar los campos obligatorios.' });
      return;
    }
    //* Nuevo request
    const request = {
      mailOrigen: this.groupCorreo.get('mailOrigen')?.value,
      mailTo: this.groupCorreo.get('mailTo')?.value,
      mailCc: this.groupCorreo.get('mailCc')?.value,
      mailBcc: this.groupCorreo.get('mailBcc')?.value,
      subject: this.groupCorreo.get('subject')?.value,
      usuario: this.storage.get('usuario'),//? Solo si es necesario enviar
      tipo: "P",//! "R" en real
      // age_codigo: 123,//!innecesario
      mensaje: this.editor.value// ¡El HTML completo del editor!
    };

    this.loadingEnvCorreo = true;

    this.servLogistica.EnviarCorreoProforma(request).subscribe({
      next: (resp) => {
        if (resp.datos.status === 200) {
          this.util.MessageDialog({
            tipo: 'ok',
            titulo: "Correo Enviado",
            mensaje: resp.meta.mensaje || 'Correo enviado correctamente.',
          })
          this.loadingEnvCorreo = false;
          this.ref.close();
        }
      },
      error: (err) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: err.meta?.mensaje || 'Error al enviar el correo' });
        this.loadingEnvCorreo = false;
      }
    });
  }

  onCerrar(): void {
    this.ref.close()
  }

  styleRow = (row: any) => {
    if (row.comprobante_Venta) {
      return { background: "#d7e3e7" }
    }
    else {
      return { background: "#ffffff" }
    }
  }

}

